export const QuestionnaireGuidance = Object.freeze({
  EXPLAIN_ADD_TO_KB:
    'By adding your security questionnaire to your knowledge base, these answers can be used to answer future security questions.',
  EXPLAIN_ACCEPT_QUESTIONNAIRE:
    'Accepting your questionnaire prevents it from being edited and allows you to add it to your knowledge base.',
})
